import { useDataChange } from 'Simple/Data.js'

export function useOnChange(props) {
  let changeHidden = useDataChange({
    context: 'question',
    path: 'hidden',
    viewPath: props.viewPath,
  })

  let changeRequired = useDataChange({
    context: 'question',
    path: 'required',
    viewPath: props.viewPath,
  })

  return function onChange(value) {
    changeHidden(value)
    if (value === true) {
      changeRequired(false)
    }
  }
}
